import React, { useMemo } from 'react';
import { useField } from 'react-final-form';
import { useParams } from 'react-router-dom';

import CopyTextInput from '@dashboard/components/form/fields/CopyTextInput';

import TriggerSectionWrapper from '../TriggerSectionWrapper';

type Props = {
  name: string;
};
export default function HttpPostTriggerCard({ name }: Props) {
  const { id: workflowId } = useParams<{ id: string }>();
  const token = useField<string>(`${name}.httpPost.token`).input.value;

  const url = useMemo(
    () => `https://live.waypointapi.com/hooks/workflows/${workflowId}?token=${token}`,
    [workflowId, token]
  );

  return (
    <TriggerSectionWrapper type="HTTP_POST">
      <CopyTextInput value={url} helperText="Send requests to this custom HTTP Post URL." />
    </TriggerSectionWrapper>
  );
}
